import { addTile } from '../data/commands/tiles';
import { useCommandEnv } from '../data/hooks';
import { Button } from '../ui/Button';
import { Sheet } from '../ui/Sheet';
import { groupDefsByModule } from './layout';

export function TilePicker({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange(open: boolean): void;
}) {
  const env = useCommandEnv();
  const groups = groupDefsByModule(env.usable);
  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
      title="Add a tile"
      description="Tiles from every module that's on."
    >
      {groups.map((g) => (
        <section key={g.moduleId} className="mb-4">
          <h3 className="mb-2 text-xs font-medium uppercase tracking-[0.06em] text-muted">
            {g.name}
          </h3>
          <ul className="flex flex-col gap-2">
            {g.defs.map((d) => (
              <li
                key={d.type}
                className="flex items-center justify-between gap-2 rounded-2xl bg-surface p-3"
              >
                <span>{d.title}</span>
                <Button
                  aria-label={`Add ${d.title}`}
                  onClick={async () => {
                    await addTile(env, d.type);
                    onOpenChange(false);
                  }}
                >
                  Add
                </Button>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </Sheet>
  );
}
